var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2362_47365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33341 15.0013V14.8346C3.33341 13.4345 3.33341 12.7344 3.6059 12.1997C3.84558 11.7293 4.22803 11.3468 4.69844 11.1071C5.23322 10.8346 5.93328 10.8346 7.33342 10.8346H12.6667C14.0669 10.8346 14.7669 10.8346 15.3017 11.1071C15.7721 11.3468 16.1546 11.7293 16.3943 12.1997C16.6667 12.7344 16.6667 13.4345 16.6667 14.8346V15.0013M3.33341 15.0013C2.41294 15.0013 1.66675 15.7475 1.66675 16.668C1.66675 17.5884 2.41294 18.3346 3.33341 18.3346C4.25389 18.3346 5.00008 17.5884 5.00008 16.668C5.00008 15.7475 4.25389 15.0013 3.33341 15.0013ZM16.6667 15.0013C15.7463 15.0013 15.0001 15.7475 15.0001 16.668C15.0001 17.5884 15.7463 18.3346 16.6667 18.3346C17.5872 18.3346 18.3334 17.5884 18.3334 16.668C18.3334 15.7475 17.5872 15.0013 16.6667 15.0013ZM10.0001 15.0013C9.07961 15.0013 8.33342 15.7475 8.33342 16.668C8.33342 17.5884 9.07961 18.3346 10.0001 18.3346C10.9206 18.3346 11.6667 17.5884 11.6667 16.668C11.6667 15.7475 10.9206 15.0013 10.0001 15.0013ZM10.0001 15.0013V6.66797M5.00008 6.66797H15.0001C15.7767 6.66797 16.1649 6.66797 16.4712 6.5411C16.8796 6.37195 17.2041 6.04749 17.3732 5.63911C17.5001 5.33282 17.5001 4.94454 17.5001 4.16797C17.5001 3.3914 17.5001 3.00311 17.3732 2.69683C17.2041 2.28845 16.8796 1.96399 16.4712 1.79484C16.1649 1.66797 15.7767 1.66797 15.0001 1.66797H5.00008C4.22351 1.66797 3.83523 1.66797 3.52894 1.79484C3.12056 1.96399 2.79611 2.28845 2.62695 2.69683C2.50008 3.00311 2.50008 3.3914 2.50008 4.16797C2.50008 4.94454 2.50008 5.33282 2.62695 5.63911C2.79611 6.04749 3.12056 6.37195 3.52894 6.5411C3.83523 6.66797 4.22351 6.66797 5.00008 6.66797Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2362_47365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFlow);
export default __webpack_public_path__ + "static/media/DataFlow.cd689cc7df06b5b50daf87dff66497e6.svg";
export { ForwardRef as ReactComponent };